import { FC } from "react";
import { Button, Modal } from "react-bootstrap";

type Props = {
  show: boolean;
  close: () => void;
  videoUrl?: string;
  helpSteps: string[];
};

export const HelpModal: FC<Props> = ({ show, close, videoUrl, helpSteps }) => {
  return (
    <>
      <Modal size="lg" show={show} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>How to Use.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h2>Steps:</h2>
          <ul>
            {helpSteps.map((help) => {
              return <li key={help}>{help}</li>;
            })}
          </ul>
          
          {videoUrl && (
            <iframe
              width="100%"
              height="415"
              src={videoUrl} //"https://www.youtube.com/embed/hNce9hFpBOY" // Replace with actual YouTube video link
              title="Video Tutorial"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={close}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
